import Slide from "../../../../../../components/Slide";
import QList from "../../../../../../components/QList";
import QHeader from "../../../../../../components/QHeader";

import BackgroundImage from "../../../../../../assets/_Chapters/_Images/background/BeratungPlanungMontage/5.webp";
import { Grid } from "@material-ui/core";

export default function WirOptimieren() {
  return (
    <Slide
      background={{
        image: BackgroundImage,
        width: "50dvw",
        align: "right",
        position: "center",
      }}
    >
      <Grid container spacing={5} alignItems="center">
        <Grid item xs={6}>
          <QHeader title="Wir optimieren Ihre Werkzeuglogistik" />
          <QList
            items={[
              "Individuell auf Sie zugeschnittene Schubladeneinlagen",
              "Übersichtliche Aufbewahrung von Werkzeugen",
              "Effiziente Schubladenaufteilung",
              "Optimale Platzausnutzung",
            ]}
          />
        </Grid>
        <Grid item xs={6}></Grid>
      </Grid>
    </Slide>
  );
}
